export const katarzynaWolska = {
    'meta': {
        'title': 'Psychiatra Katarzyna Wolska • Centrum COLLIGO',
        'description': 'Jestem lekarzem specjalistą psychiatrii. W pracy zawodowej zajmuje się diagnostyką i leczeniem zaburzeń depresyjnych, lękowych, zaburzeń snu i innych.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psychiatra-katarzyna-wolska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/female-avatar.jpg',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra w Bydgoszczy Katarzyna Wolska'
        }
    }
}